class CustomFrame extends HTMLElement {
  constructor() {
    super();
    this.svg = null;
    this.onUpdate = this.updateSvg.bind(this);
    this.resizeObs = null;
  }

  connectedCallback() {
    this.svg = this.querySelector("svg");
    if (!this.svg) return;

    // Initial paint + next tick (in case content/styles settle)
    this.updateSvg();
    requestAnimationFrame(this.updateSvg.bind(this));

    // Recalculate on element resize
    this.resizeObs = new ResizeObserver(this.onUpdate);
    this.resizeObs.observe(this);

    // Refresh inside Shopify theme editor section update
    if (typeof Shopify !== "undefined" && Shopify.designMode) {
      document.addEventListener("shopify:section:load", this.onUpdate);
    }
  }

  disconnectedCallback() {
    if (this.resizeObs) this.resizeObs.disconnect();
    if (typeof Shopify !== "undefined" && Shopify.designMode) {
      document.removeEventListener("shopify:section:load", this.onUpdate);
    }
  }

  updateSvg() {
    const svg = this.svg;
    if (!svg) return;

    const containerWidth = this.offsetWidth;
    const containerHeight = this.offsetHeight;

    const marginX = parseInt(this.getAttribute("data-margin-x") || "0");
    const marginY = parseInt(this.getAttribute("data-margin-y") || "0");

    const viewBox = svg.getAttribute("viewBox").split(" ").map(Number);
    const vbWidth = viewBox[2];

    let newVbHeight = vbWidth * ((containerHeight - marginY) / (containerWidth - marginX));

    if (containerWidth > 1920) {
      const parentSection = this.closest(".shopify-section");
      const isRelated = parentSection && parentSection.id.includes("related-products");

      if (!isRelated) {
        const maxRatio = 1.5;
        const currentRatio = vbWidth / newVbHeight;
        if (currentRatio > maxRatio) {
          newVbHeight = vbWidth / maxRatio;
        }
      }
    }

    viewBox[3] = parseInt(newVbHeight);
    svg.setAttribute("viewBox", viewBox.join(" "));

    const ORIGINAL_BOTTOM_Y = 797;
    const SHIFT_THRESHOLD = 700;
    const yDiff = newVbHeight - ORIGINAL_BOTTOM_Y;

    svg.querySelectorAll("path").forEach(path => {
      if (!path.hasAttribute("data-original-d")) {
        path.setAttribute("data-original-d", path.getAttribute("d"));
      }

      const originalD = path.getAttribute("data-original-d");

      const d = originalD.replace(/([ ,])([7-9]\d{2}(?:\.\d+)?)/g, (match, sep, yVal) => {
        const y = parseFloat(yVal);
        if (y > SHIFT_THRESHOLD) {
          const newY = (y + yDiff).toFixed(3).replace(/\.?0+$/, "");
          return sep + newY;
        }
        return match;
      });

      path.setAttribute("d", d);
    });
  }
}

customElements.define("custom-frame", CustomFrame);
